export const SUBSCRIPTION_TYPES = {
    FREE: 'free',
    PREMIUM: 'premium',
    PLATINUM: 'platinum',
    CONTRIBUTING_EDITOR: 'contributing_editor',
};

export function writesAlerts(planType) {
    return (
        planType === SUBSCRIPTION_TYPES.CONTRIBUTING_EDITOR ||
        planType === SUBSCRIPTION_TYPES.PREMIUM
    );
}

export function hasUnlimitedResponses(planType) {
    return (
        planType === SUBSCRIPTION_TYPES.PLATINUM ||
        planType === SUBSCRIPTION_TYPES.CONTRIBUTING_EDITOR
    );
}
